/**
 * Instance Overview Tab Component
 *
 * Displays instance metadata and additional details.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { InstanceDetail } from '../../../types'

interface InstanceOverviewProps {
    instance?: InstanceDetail
}

const InstanceOverview = ({ instance }: InstanceOverviewProps) => {
    if (!instance) {
        return null
    }

    const hasMetadata =
        instance.metadata && Object.keys(instance.metadata).length > 0

    return (
        <div className="mt-2 space-y-4">
            {hasMetadata && (
                <Card>
                    <CardHeader>
                        <CardTitle>Metadata</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {Object.entries(instance.metadata || {}).map(
                                ([key, value]) => (
                                    <div
                                        key={key}
                                        className="flex flex-col space-y-1"
                                    >
                                        <span className="text-sm text-muted-foreground">
                                            {key}
                                        </span>
                                        <span className="text-sm font-medium">
                                            {typeof value === 'object'
                                                ? JSON.stringify(value)
                                                : String(value)}
                                        </span>
                                    </div>
                                )
                            )}
                        </div>
                    </CardContent>
                </Card>
            )}

            {!hasMetadata && (
                <Card>
                    <CardHeader>
                        <CardTitle>Overview</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-center py-8 text-muted-foreground">
                            No additional metadata available for this instance.
                        </div>
                    </CardContent>
                </Card>
            )}
        </div>
    )
}

export default InstanceOverview
